import styled from 'styled-components';

import * as mx from 'core/styles/mixins';

export const Wrapper = styled.header`
	background-color: ${({ theme }) => theme.global.page.color};
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 60px 0 24px;

	// [DDMP-13075] as per Mark Galulu, will only use spacings divisible by 8px moving forward
	${mx.bp('m')`
		padding: 80px 0 32px;
	`}

	img {
		width: 237px;
	}
`;
